import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';

import PostList from 'Components/posts/PostListComponent';
import Breadcrumb from 'Components/common/BreadcrumbComponent';
import InThreadAdComponent from 'Components/ads/inThreadAdComponent';

import { fetchThread, resetThread } from 'Actions/ThreadviewActions';
import { preLoadTaboola, refreshTaboola, refreshRevContent,
	checkAdsPermissions, resetHiddenAdsPerUser, trackPageView, onPageView
} from 'Actions/adsActions';

import threadViewSelector from 'Selectors/threadViewSelector';

import PollData from 'Components/posts/PollDataComponent';
import AdComponent from 'Components/ads/AdComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

import InfiniteScroll from 'Components/infiniteScroll/InfiniteScrollComponent';
import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { resetGallery } from 'Actions/PhotoGalleryActions';

class ThreadViewComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loadRevContent: false,
			loadTaboola: false,
			loadTaboolaWidget: false
		};
	}

	componentDidMount() {
		let page = this.props.location.query.page,
			post = this.props.location.query.postid;

		this.props.dispatch( resetGallery() );
		this.props.dispatch( resetThread() );
		this.props.dispatch( resetInfinite() );

		this.props.dispatch( fetchThread({
			id: parseInt( this.props.routeParams.threadId ),
			page: ( page ? parseInt( page ) : null ),
			postid: ( post ? parseInt( post ) : null )
		}));

		// Checking ad Permissions
		if( this.props.forumId ) {
			this.props.dispatch( checkAdsPermissions( this.props.forumId ) );
			this.props.dispatch( resetHiddenAdsPerUser() );
		}

		this.props.dispatch( preLoadTaboola() );
	}

	componentWillUnmount() {
		this.props.dispatch( resetGallery() );
		this.props.dispatch( resetThread() );
		this.props.dispatch( resetInfinite() );
	}

	componentDidUpdate( prevProps, prevState ) {
		if( this.props.threadview.isFetching === false ) {
			if( prevState.loadTaboola === false && this.state.loadTaboola === true ) {
				refreshTaboola( 'taboola' );
			}
			if( prevState.loadRevContent === false && this.state.loadRevContent === true ) {
				this.props.dispatch( refreshRevContent() );
			}
			if( prevState.loadTaboolaWidget === false && this.state.loadTaboolaWidget === true ) {
				refreshTaboola( 'recirculation' );
			}

			let postContainer = null;
			if( this.props.location.query.postid ) {
				let postid = this.props.location.query.postid;
				postContainer = document.getElementById( 'post_container_' + postid );

				if( postid && postContainer ) {
					let postPage = postContainer.parentNode.className.match( /page_(\d+)/ ),
						page = postPage && postPage.length > 0 ? parseInt( postPage[ 1 ] ) : this.props.meta.page;

					// rewriting the url to the correct one
					let pathname = '/topics/' + this.props.meta.threadid,
						query = Object.assign( {}, this.props.location.query );

					query.page = page;

					// keep postid in query until we are on the thread
					if( parseInt( this.props.params.threadId ) === parseInt( this.props.meta.threadid ) ) {
						delete query.postid;
						delete query.s;
					} else {
						query.postid = postid;
						query.s = 1;
					}

					this.props.dispatch( replace( {
						pathname: pathname,
						query: query
					} ) );


					// scrolling to the post
					window.scrollTo( 0, postContainer.offsetTop - 15 );
				}
			} else if( !this.props.location.query.page || parseInt( this.props.location.query.page ) === 0 ) {
				if( this.props.threadview.postid ) {
					postContainer = document.getElementById( 'post_container_' + this.props.threadview.postid );
					if( postContainer ) {
						// scrolling to the post
						window.scrollTo( 0, postContainer.offsetTop - 15 );
					}
				} else {
					window.scrollTo( 0, window.scrollY + 5 );
				}
			}
		}
	}

	shouldComponentUpdate( nextProps, nextState ) {
		return (
			nextProps.threadview.loaded !== this.props.threadview.loaded
			|| nextProps.threadview.isFetching !== this.props.threadview.isFetching
			|| nextProps.threadview.result.posts.length !== this.props.threadview.result.posts.length
			|| nextProps.threadview.threadid !== this.props.threadview.threadid
			|| nextState.loadRevContent !== this.state.loadRevContent
			|| nextState.loadTaboola !== this.state.loadTaboola
			|| nextState.loadTaboolaWidget !== this.state.loadTaboolaWidget
			|| nextProps.location.query !== this.props.location.query
		);
	}

	componentWillReceiveProps(nextProps) {
		if(
			this.props.routeParams.threadId !== nextProps.routeParams.threadId ||
			this.props.location.query.postid !== nextProps.location.query.postid
		) {
			let page = parseInt( nextProps.location.query.page ),
				post = nextProps.location.query.postid;

			// only refresh if we are not already in the thread and page we want
			let oldThreadId = this.props.threadview.threadid,
				newThreadid = nextProps.threadview.threadid,
				oldPage = parseInt( this.props.threadview.page );

			if(
				oldThreadId !== newThreadid ||
				( nextProps.location.query.postid && nextProps.location.query.s === undefined )
			) {
				this.props.dispatch( resetGallery() );
				this.props.dispatch( resetInfinite() );
				this.props.dispatch( resetThread() );
			}

			if( !( oldThreadId === newThreadid && oldPage === page ) ) {
				this.props.dispatch( fetchThread( {
					id: nextProps.routeParams.threadId,
					page: ( page ? parseInt( page ) : null ),
					postid: ( post ? parseInt( post ) : null )
				} ) );
			}
		} else {
			if( nextProps.threadview.isFetching === false && nextProps.currentPage && nextProps.totalPages ) {
				this.setState( {
					loadTaboola: nextProps.forumSite.f_taboola && !nextProps.forumSite.f_revcontent && nextProps.currentPage === nextProps.totalPages,
					loadRevContent: nextProps.forumSite.f_revcontent && nextProps.currentPage === nextProps.totalPages,
					loadTaboolaWidget: parseInt( nextProps.currentPage ) === 1
				} );
			}
		}

		if( nextProps.forumId !== this.props.forumId ) {
			this.props.dispatch( checkAdsPermissions( nextProps.forumId ) );
		}
		if( nextProps.threadview.threadid !== this.props.threadview.threadid ) {
			this.props.dispatch( resetHiddenAdsPerUser() );
		}
		if( nextProps.threadview.loaded && nextProps.threadview.loaded !== this.props.threadview.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView( { captify: "" } ) );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	loadPage = ( page, forceRefresh ) => {
		this.props.dispatch( fetchThread( {
			id: parseInt( this.props.routeParams.threadId ),
			page: page,
			forceRefresh: forceRefresh
		} ) );
	};

	render() {
		const {threadview: { threadid, loaded, isFetching, entities: { topics }, result: { posts } } } = this.props;

		if (!loaded) {
			return <LoaderCss />;
		}

		let campaignAd = <AdComponent adType="505" adName="Campaign_Top_Ad" />,
			bottomAdUnit = <AdComponent key={ `thread_BottomAd` } adType="2" adName="Bottom_Content_Rectangle"  isFetching={ isFetching } />,
			taboolaAd = posts.length > 0 && this.state.loadTaboola ? <InThreadAdComponent adContainerId="taboola-mobile-below-article-thumbnails" className="taboola-placeholder ad-card" /> : null,
			revContent = posts.length > 0 && this.state.loadRevContent ? <InThreadAdComponent adContainerId="rcjsload_vs1vs1"  className="ad-card" /> : null;

		let topNote = isFetching === false && ( topics[ threadid ].isDeleted || !topics[ threadid ].isOpen ) ? <div className="topic-alert">This topic is { topics[ threadid ].isDeleted ? 'deleted' : ( !topics[ threadid ].isOpen ? 'closed' : '' ) }</div> : '';

		return (
			<div>
				<Breadcrumb routeParams={this.props.routeParams} />
				{ topNote }
				{ campaignAd }
				<PollData />
				<InfiniteScroll
					scrollRef={ i => this.infiniteScroll = i }
					isFetching={ isFetching }
					loadPage={ this.loadPage }
					location={ this.props.location }>
						<PostList />
				</InfiniteScroll>
				{ taboolaAd }
				{ revContent }
				{ bottomAdUnit }
			</div>
		);
	}
}

export default connect( threadViewSelector )( ThreadViewComponent );



// WEBPACK FOOTER //
// ./src/components/ThreadViewComponent.js